import React from 'react';

export default function FloatingCTA() {
  const ctas = [
    {
      id: 'phone',
      href: 'tel:+4550358378',
      icon: 'fa-solid fa-phone',
      label: 'Ring til os',
      bgColor: 'bg-brand-green hover:bg-[#0f8247]',
      textColor: 'text-white',
    },
    {
      id: 'email',
      href: 'mailto:info@energimaeglere.dk',
      icon: 'fa-solid fa-envelope',
      label: 'Send en e-mail',
      bgColor: 'bg-brand-blue hover:bg-brand-orange-hover',
      textColor: 'text-white',
    },
  ];

  return (
    <div className="fixed right-6 bottom-8 z-50 flex flex-col gap-3 pointer-events-none">
      {ctas.map((cta) => (
        <div key={cta.id} className="relative group pointer-events-auto">
          {/* Tooltip */}
          <span className="absolute right-14 top-1/2 -translate-y-1/2 bg-brand-dark text-white text-xs font-medium py-1.5 px-3 rounded-none whitespace-nowrap opacity-0 group-hover:opacity-100 transition-all duration-300 translate-x-2 group-hover:translate-x-0 pointer-events-none shadow-md border border-brand-light/10">
            {cta.label}
          </span>

          {/* Button */}
          <a
            href={cta.href}
            target={cta.href.startsWith('http') ? '_blank' : undefined}
            rel={cta.href.startsWith('http') ? 'noopener noreferrer' : undefined}
            className={`w-12 h-12 flex items-center justify-center ${cta.bgColor} ${cta.textColor} rounded-none shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-blue`}
            aria-label={cta.label}
          >
            <i className={`${cta.icon} text-lg`} aria-hidden="true" />
          </a>
        </div>
      ))}
    </div>
  );
}
